module.exports = __webpack_public_path__ + "static/media/icon／icon_jiaoyixiangqing_yiwancheng@3x.40a21d1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon／icon_jiaoyixiangqing_yiwancheng@3x.png
// module id = 1779
// module chunks = 0 1